import { registerSectionType } from "../../utils/sectionRegistry";
import { CarruselSection } from "../sectionComponents";

registerSectionType({
  type: "carrusel",
  label: "Carrusel",
  layout: "cards",
  previewBlocks: ["Slide", "Slide", "Slide"],
  getDefaults: () => ({ type: "carrusel", title: "", description: "", itemsText: "", draft_image: "", draft_title: "", draft_description: "", draft_link: "" }),
  editorFields: [
    { key: "image", label: "Imagen del slide", placeholder: "https://..." },
    { key: "title", label: "Titulo del slide" },
    { key: "description", label: "Descripcion del slide", input: "textarea" },
    { key: "link", label: "Enlace (URL)", placeholder: "https://... (opcional)" },
  ],
  itemLabel: "slide",
  render: (section, index) => <CarruselSection section={section} index={index} />,
});
